<template>
  <div class="dialogs">
    <!--外层的遮罩 点击事件用来关闭弹窗，isShow控制弹窗显示 隐藏的props-->
    <div class="dialogs-cover back" v-if="isShow" @click="closeMyself"></div>
    <!-- transition 这里可以加一些简单的动画效果 -->
    <transition name="drop">
      <!--style 通过props 控制内容的样式  -->
      <div
        class="dialogs-content"
        :style="{top:topDistance+'%',width:widNum+'%',left:leftSite+'%'}"
        v-if="isShow"
      >
        <div class="dialogs_head back">
          <slot name="header"></slot>
        </div>
        <div class="dialogs_main" :style="{paddingTop:pdt+'px',paddingBottom:pdb+'px'}">
          <slot name="main"></slot>
        </div>
      </div>
    </transition>
  </div>
</template> 
<script>
/** 弹窗组件*/
export default {
  name: "dialogs",
  props: {
    isShow: {
      type: Boolean,
      default: false,
      required: true
    },
    widNum: {
      type: Number,
      default: 86.5
    },
    leftSite: {
      // 左定位
      type: Number,
      default: 6.5
    },
    topDistance: {
      //top上边距
      type: Number,
      default: 35
    },
    pdt: {
      //上padding
      type: Number,
      default: 22
    },
    pdb: {
      //下padding
      type: Number,
      default: 47
    }
  },
  methods: {
    closeMyself() {
      this.$emit("on-close");
    }
  }
};
</script>
<style >
/** 弹窗动画*/
.drop-enter-active {
  transition: all 0.5s ease;
}
.drop-leave-active {
  transition: all 0.3s ease;
}
.drop-enter {
  transform: translateY(500px);
}
.drop-leave-active {
  transform: translateY(500px);
}
.dialogs {
  position: relative;
  color: #2e2c2d;
  font-size: 16px;
}
.dialogs_main{
  width: 100%;
}
.dialogs-cover {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dialogs-content {
  position: fixed;
  top: 35%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 3;
}
.dialogs_head {
  width: 86.5%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dialog_main {
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 86.5%;
  padding: 22px 0 47px 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.foot_close {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fcca03;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: -25px;
}
.close_img {
  width: 42px;
  height: 42px;
}
</style>


// WEBPACK FOOTER //
// src/components/container/dialog.vue